import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@auth/auth.service';
import { AutoLogoutService } from '@auth/auto-logout-service.service';
import { BovModel } from '@dto/custody-model-bov.dto';
import { CustodyEarningsFilterType, CustodyFilterType, CustodyInputTypeEnum, CustodyTabEnum } from '@model/enum/custody-model.enum';
import { StatusConnection } from '@model/status-connection';
import { AuthServer } from '@services/auth-server.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { PositionService } from '@services/webFeeder/sckt-position.service';
import { StatusOmsService } from '@services/webFeeder/sckt-status-oms.service';
import { AppUtils } from '@utils/app.utils';
import { Constants } from '@utils/constants';
import { NotificationsService } from 'angular2-notifications';
import { Subscription, of } from 'rxjs';
import * as Highcharts from 'highcharts';
import { BilletOrderModalService } from '@services/billet-order-modal.service';
import { SideEnum } from '@model/enum/side.enum';
import { take } from 'rxjs';
import { startWith } from 'rxjs';
import { map } from 'rxjs';

@Component({
  selector: 'app-custody-consult',
  templateUrl: './custody-consult.component.html'
})
export class CustodyConsultComponent implements OnInit, OnDestroy {

  title = Constants.TITLE_CARD_MODAL_CUSTODY;
  whiteLabel = this._configService.getConfigWhitelabel();
  msgStatusOmsOffile = Constants.MSG_STATUS_OFFLINE_OMS;
  public msgOffline = Constants.MSG_OFFLINE_NEGOTIATION_02;
  public msgQuoteInvalid = Constants.WORKSPACE_MSG005;
  private subscriptions: Array<Subscription> = [];
  loading = true;
  loadingGraph = true;
  statusOmsOnline: boolean;
  showEmptyData: boolean;
  showInpuEmptytDate = true;
  showResult: boolean;
  tabsCustody = Constants.CUSTODY_TAB_FILTER;
  account: string;
  model: any = [];
  checkCtrl: FormControl;
  dateCustodyFilter: Date = new Date();
  maxDate: Date = new Date();
  custodyCacheSubscription: Subscription;
  custodySubscription: Subscription;
  columnDisplayTables = [];
  private chartOpts: any;
  @ViewChild('chartClass') chartElClass: ElementRef;
  @ViewChild('chartSector') chartElSector: ElementRef;
  profitClosedActions = 0;
  percentActions = 0;
  valueActions = 0;
  profitClosedBdr = 0;
  percentBdr = 0;
  valueBdr = 0;
  profitClosedBtcD = 0;
  percentBtcD = 0;
  valueBtcD = 0;
  profitClosedBtcT = 0;
  percentBtcT = 0;
  valueBtcT = 0;
  profitClosedEtf = 0;
  percentEtf = 0;
  valueEtf = 0;
  profitClosedFii = 0;
  percentFii = 0;
  valueFii = 0;
  profitClosedOption = 0;
  percentOption = 0;
  valueOption = 0;
  profitClosedOthers = 0;
  percentOthers = 0;
  valueOthers = 0;
  profitClosedTerm = 0;
  percentTerm = 0;
  valueTerm = 0;
  totalValueGraph = 0;
  positionSumary = [];
  showGraph = false;
  wasEarningsCreditedFetched = false;
  msgSelectDateBeginAndFinal = Constants.MSG_SELECT_DATE_BEGIN_FINAL;
  msgSelectDateBeginAndFinalComplement = Constants.MSG_SELECT_DATE_BEGIN_FINAL_COMPLEMENT;
  msgSelectDate = Constants.MSG_SELECT_DATE;
  msgSelectDateComplement = Constants.MSG_SELECT_DATE_COMLEMENT;

  formats = environment.formats;

  gridBovTablePositionCurrent: any = [];
  columnBovTablePositionCurrent = [
    { headerName: '', field: null, value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
    { headerName: 'Ativo', field: 'quote', value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
    { headerName: 'Tipo', field: 'quoteType', value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
    { headerName: 'Qtd. Inicial', field: 'initQuantity', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Qtd. Atual', field: 'currentQuantity', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Atual', field: 'lastTrade', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Fech.', field: 'previusTrade', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Var. (%)', field: 'variation', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Médio', field: 'averagePrice', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Valor Inicial', field: 'valueInit', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Valor Atual', field: 'valueCurrent', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Qtd. Exec Compra', field: 'executedBuy', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'Qtd. Exec Venda', field: 'executedSell', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'Qtd. Ab. Compra', field: 'openBuy', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'Qtd. Ab. Venda', field: 'openSell', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'Qtd. Bloqueada', field: 'quantityBlocked', value: null, cellClass: 'm-100 txt-center', },
    { headerName: 'Qtd. Disponível', field: 'quantityReleased', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'D+0', field: 'quantityD1', value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
    { headerName: 'D+1', field: 'quantityD2', value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
    { headerName: 'D+2', field: 'quantityD3', value: null, cellClass: 'm-80 txt-center', cellRenderer: '' },
  ];

  gridBovTablePositionDay: any = [];
  columnBovTablePositionDay = [
    { headerName: '', field: null, value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'Ativo', field: 'quote', value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'C. Exec. Dia', field: 'executedBuy', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'V. Exec. Dia', field: 'executedSell', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'NET Dia', field: 'netDay', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Med. Aberto', field: 'avgValueDaytradeToday', value: null, cellClass: 'm-130 txt-center', },
    { headerName: ' L/P Aberto', field: 'openProfitLoss', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'L/P Fechado', field: 'closedProfitLoss', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' }
  ];

  gridBovTablePositionHistory: any = [];
  columnBovTablePositionHistory = [
    { headerName: '-', field: null, cellClass: 'm-150 ', },
    { headerName: 'Ativo', field: 'symbol', cellClass: 'm-150 ', },
    { headerName: 'Q. Inicial', field: 'quantity', cellClass: 'm-150 txt-center', cellRenderer: '' },
    { headerName: 'Data', field: 'eventDate', cellClass: 'm-250 ' },
    { headerName: 'Tipo', field: 'portfolioType', cellClass: 'm-250 ' },
  ];

  gridBovTablePositionSumaryClass: any = [];
  gridBovTablePositionSumarySector: any = [];
  columnBovTablePositionSumary = [
    { headerName: 'Ativo', field: 'symbol', cellClass: 'm-150 ', },
    { headerName: 'Valor', field: 'quantity', cellClass: 'm-150 txt-center', cellRenderer: '' },
    { headerName: 'Porcent.', field: 'eventDate', cellClass: 'm-250 txt-center' },
    { headerName: 'L/P Fechado', field: 'portfolioType', cellClass: 'm-250 txt-center' },
  ];

  gridBmfTablePositionCurrent: any = [];
  columnBmfTablePositionCurrent = [
    { headerName: '', field: null, value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'Ativo', field: 'quote', value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'Qtd. Inicial', field: 'initQuantity', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Posição Atual', field: 'currentQuantity', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Compras Exec', field: 'executedBuy', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'Vendas Exec', field: 'executedSell', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'Pr. Atual', field: 'lastTrade', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Fech.', field: 'previusTrade', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Var. (%)', field: 'variation', value: null, cellClass: 'm-100 txt-center', cellRenderer: '' },
    { headerName: 'Ajuste', field: 'valueAdjustedAmount', value: null, cellClass: 'm-50 txt-center', cellRenderer: '' }
  ];

  gridBmfTablePositionDay: any = [];
  columnBmfTablePositionDay = [
    { headerName: '', field: null, value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'Ativo', field: 'quote', value: null, cellClass: 'm-80 txt-center', },
    { headerName: 'C. Exec. Dia', field: 'executedBuy', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'V. Exec. Dia', field: 'executedSell', value: null, cellClass: 'm-130 txt-center', cellRenderer: this.renderNumber.bind(this) },
    { headerName: 'NET Dia', field: 'netDay', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'Pr. Med. Aberto', field: 'averagePricePos', value: null, cellClass: 'm-130 txt-center', },
    { headerName: 'L/P Aberto', field: 'openProfitLoss', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' },
    { headerName: 'L/P Fechado', field: 'closedProfitLoss', value: null, cellClass: 'm-130 txt-center', cellRenderer: '' }
  ];

  gridEarningsCredited: any = [];
  columnEarningsCredited = [
    { headerName: '', field: null, cellClass: 'm-200 txt-left' },
    { headerName: 'Nome', field: 'issuingName', cellClass: 'm-200 txt-left' },
    { headerName: 'Ativo', field: 'symbol', cellClass: 'm-100 ' },
    { headerName: 'Data', field: 'eventDate', cellClass: 'm-150 ' },
    { headerName: 'Tipo De Evento', field: 'productName', cellClass: 'm-350 txt-left' },
    { headerName: 'Quantidade', field: 'quantity', cellClass: 'm-150 txt-right', cellRenderer: '' },
    { headerName: 'Valor Bruto', field: 'bruteValue', cellClass: 'm-150 txt-right', cellRenderer: this.renderNumber.bind(this) },
  ];

  gridEarningsProvisioned: any = [];
  columnEarningsProvisioned = [
    { headerName: '', field: null, cellClass: 'm-180 ' },
    { headerName: 'Nome', field: 'issuingName', cellClass: 'm-180 ' },
    { headerName: 'Ativo', field: 'symbol', cellClass: 'm-180 ' },
    { headerName: 'Prev. De Pagamento', field: 'liquidityDate', cellClass: 'm-180 liquidityDate' },
    { headerName: 'Tipo de Evento', field: 'productName', cellClass: 'm-250 ' },
    { headerName: 'Quantidade', field: 'quantity', cellClass: 'm-150 txt-right', cellRenderer: '' },
    { headerName: 'Valor Bruto', field: 'bruteValue', cellClass: 'm-150 ' }
  ];

  @HostListener('mousemove')
  onMouseMove() {
    this._autoLogoutService.resetTime();
  }

  @HostListener('click')
  onClick() {
    this._autoLogoutService.resetTime();
  }

  constructor(
    public dialogRef: MatDialogRef<CustodyConsultComponent>,
    private _autoLogoutService: AutoLogoutService,
    private _authService: AuthService,
    private _configService: ConfigService,
    private _statusOmsService: StatusOmsService,
    private _notificationService: NotificationsService,
    private _positionService: PositionService,
    private _authServer: AuthServer,
    private _datePipe: DatePipe,
    private _billetOrderService: BilletOrderModalService,
  ) {
    this.configInputsAndFilters(0);
    this.dateCustodyFilter = null;
    this.checkCtrl = new FormControl();
    const checkbox = this.checkCtrl.valueChanges
      .pipe(
        startWith(CustodyFilterType.POSITON_CURRENT),
        map(value => {
          if (value !== null && value !== undefined) {
            if (value !== CustodyFilterType.POSITON_HISTORY) {
              this.dateCustodyFilter = null;
              if (this.model.tabSelected === CustodyTabEnum.BOVESPA
                && this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_HISTORY) {
                this.showEmptyData = false;
              } else {
                this.showEmptyData = true;
              }
              this.subscribePositions();
            }
          }
        })
      )
      ;
    checkbox.subscribe();
  }

  ngOnInit() {

    if (!this._authService.isAuthenticated) {
      this.dialogRef.close();
      this._configService.REDIRECT_LOGOUT();
      this._configService.deleteCookie();
    } else {
      this.subscriptions.push(this._statusOmsService.messagesStatusOms
        .subscribe(statusOms => {
          if (statusOms === StatusConnection.ERROR) {
            this.statusOmsOnline = false;
          } else {
            this.statusOmsOnline = true;
            this.account = this._configService.getBrokerAccountSelected();
            this._configService.writeLog(this.title + ' > Account: ' + this.account);
            if (this.account) {
              this.loading = false;
            }
          }
        }));
    }
  }

  ngOnDestroy() {
    this.custodySubscription && this.custodySubscription.unsubscribe();
    this.custodyCacheSubscription && this.custodyCacheSubscription.unsubscribe();
    if (this._positionService && this.account) {
      this._positionService.unsubscribePosition(this.account, Constants.TITLE_CARD_MODAL_CUSTODY);
    }
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  configInputsAndFilters(tabId) {
    // TODO: Debug - Config Modal
    // console.log('\n\n\n------------------------------ INICIO CONFIG ------------------------------');
    this.model = [];
    if (!this.whiteLabel.custody.showPositionBovespa) {
      this.removeTab(CustodyTabEnum.BOVESPA);
    }
    if (!this.whiteLabel.custody.showPositionBMF) {
      this.removeTab(CustodyTabEnum.BMF);
    }
    if (!this.whiteLabel.custody.showPositionEarnings) {
      this.removeTab(CustodyTabEnum.PROVENTOS);
    }
    this.model.tabConfig = this.tabsCustody[tabId ? tabId : 0];
    if (this.model.tabConfig) {
      this.columnDisplayTables = [];
      this.model.tabSelected = this.model.tabConfig.id;
      if (this.model.tabConfig && this.model.tabConfig.filters) {
        if (!this.whiteLabel.custody.showPositionHistoryBov) {
          const filterPosition = this.model.tabConfig.filters.findIndex(x => x.id === CustodyFilterType.POSITON_HISTORY);
          if (filterPosition !== -1) {
            this.model.tabConfig.filters.splice(filterPosition, 1);
          }
        }
        if (this.model.tabConfig.filters && this.model.tabConfig.filters.length > 0) {
          this.model.tabFilterRadioSelected = this.model.tabConfig.filters[0].id;
          this.model.tabFilterRadioValue = this.model.tabConfig.filters[0].webfeeder;
        }
        this.model.filtersInputTab = this.model.tabConfig.filters[this.model.tabFilterRadioSelected].inputs
          ? this.model.tabConfig.filters[this.model.tabFilterRadioSelected].inputs : [];
        this.changeDisplayTables(this.model.tabSelected, this.model.tabFilterRadioSelected);
        // TODO: Debug - Config Modal
        // console.log('Model (model): ', this.model);
        // console.log('TAB > Config (model.tabConfig): ', this.model.tabConfig);
        // console.log('TAB > Selecionada (model.tabSelected): ', this.model.tabSelected + ' > '
        //   + (this.model.tabConfig.id === this.model.tabSelected ? this.model.tabConfig.value : 'Não Encontrada'));
        // console.log('Filtros > Radios (model.tabConfig.filters): ', this.model.tabConfig.filters);
        // console.log('Filtros > Radio Selecionado (model.tabFilterRadioSelected): ', this.model.tabFilterRadioSelected
        //   + ' > ' + this.model.tabConfig.filters.find(x => x.id === this.model.tabFilterRadioSelected).desc);
        // console.log('Inputs > Inputs (model.filtersInputTab): ', this.model.filtersInputTab);
      }
      // console.log('------------------------------ FIM CONFIG ------------------------------\n\n');
    }
  }

  removeTab(tab) {
    const tabPosition = this.tabsCustody.findIndex(x => x.id === tab);
    if (tabPosition !== -1) {
      this.tabsCustody.splice(tabPosition, 1);
    }
  }

  changeTab(tab) {
    if (tab && tab.id !== this.model.tabSelected) {
      this.model = [];
      this.configInputsAndFilters(tab.id);
    }
  }

  changeDisplayTables(tabSelected: number, tabFilterRadioSelected: number) {
    if (tabSelected === CustodyTabEnum.BOVESPA) {
      if (tabFilterRadioSelected === CustodyFilterType.POSITON_CURRENT) {
        this.columnDisplayTables = this.columnBovTablePositionCurrent;
      } else if (tabFilterRadioSelected === CustodyFilterType.POSITON_DAY) {
        this.columnDisplayTables = this.columnBovTablePositionDay;
      } else if (tabFilterRadioSelected === CustodyFilterType.POSITON_HISTORY) {
        this.columnDisplayTables = this.columnBovTablePositionHistory;
      } else if (tabFilterRadioSelected === CustodyFilterType.POSITION_SUMARY) {
        this.columnDisplayTables = this.columnBovTablePositionSumary;
      }
    } else if (tabSelected === CustodyTabEnum.BMF) {
      this.columnDisplayTables = tabFilterRadioSelected === CustodyFilterType.POSITON_DAY ? this.columnBmfTablePositionDay : this.columnBmfTablePositionCurrent;
    } else if (tabSelected === CustodyTabEnum.PROVENTOS) {
      if (tabFilterRadioSelected === CustodyFilterType.POSITION_CREDITED) {
        this.columnDisplayTables = this.columnEarningsCredited;
        this.wasEarningsCreditedFetched = false;
      } else if (tabFilterRadioSelected === CustodyFilterType.POSITION_PROVISIONED) {
        this.columnDisplayTables = this.columnEarningsProvisioned;
      }
    }
    // TODO: MODO DEBUG
    // console.log('Model (model): ', this.model);
    // console.log('TAB > Config (model.tabConfig): ', this.model.tabConfig);
    // console.log('TAB > Selecionada (model.tabSelected): ', this.model.tabSelected + ' > '
    //   + (this.model.tabConfig.id === this.model.tabSelected ? this.model.tabConfig.value : 'Não Encontrada'));
    // console.log('Filtros > Radios (model.tabConfig.filters): ', this.model.tabConfig.filters);
    // console.log('Filtros > Radio Selecionado (model.tabFilterRadioSelected): ', this.model.tabFilterRadioSelected
    //   + ' > ' + this.model.tabConfig.filters.find(x => x.id === this.model.tabFilterRadioSelected).desc);
    // console.log('Inputs > Inputs (model.filtersInputTab): ', this.model.filtersInputTab);
  }

  changeFilterTypeRadio(filter, indexTabGroup?: number) {
    if (filter && this.model.tabFilterRadioSelected !== filter.id) {
      this.loading = true;
      this.model.tabFilterRadioSelected = filter.id;
      this.model.tabFilterRadioValue = filter.webfeeder;
      this.clearInputsValue();
      if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITION_PROVISIONED) {
        this.model.initialDate = new Date();
        this.search();
      } else if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITION_SUMARY) {
        if (!this.chartOpts) {
          this.getPositionSumary(indexTabGroup ? indexTabGroup : CustodyFilterType.ASSET_CLASS);
        }
      }
      this.changeDisplayTables(this.model.tabSelected, this.model.tabFilterRadioSelected);
      this.loading = false;
    }
  }

  changeTabGroup(tab) {
    this.loadingGraph = true;
    this.clearInputsValue();
    this.getPositionSumary(tab && tab.index ? tab.index : CustodyFilterType.ASSET_CLASS);
  }

  clearInputsValue() {
    this.showInpuEmptytDate = true;
    this.wasEarningsCreditedFetched = false;
    let inputTemp;
    if (this.model.tabConfig.filters) {
      const filtersTemp = this.model.tabConfig.filters.find(x => x.id === this.model.tabFilterRadioSelected);
      inputTemp = filtersTemp && filtersTemp.inputs ? filtersTemp.inputs : null;
    }
    if (inputTemp) {
      inputTemp.forEach(element => {
        element.value = null;
      });
    }
    this.model.initialDate = null;
    this.model.endDate = null;
    this.gridEarningsCredited = [];
    this.gridEarningsProvisioned = [];
    this.gridBovTablePositionHistory = [];
    this.profitClosedActions = 0;
    this.percentActions = 0;
    this.valueActions = 0;
    this.profitClosedBdr = 0;
    this.percentBdr = 0;
    this.valueBdr = 0;
    this.profitClosedBtcD = 0;
    this.percentBtcD = 0;
    this.valueBtcD = 0;
    this.profitClosedBtcT = 0;
    this.percentBtcT = 0;
    this.valueBtcT = 0;
    this.profitClosedEtf = 0;
    this.percentEtf = 0;
    this.valueEtf = 0;
    this.profitClosedFii = 0;
    this.percentFii = 0;
    this.valueFii = 0;
    this.profitClosedOption = 0;
    this.percentOption = 0;
    this.valueOption = 0;
    this.profitClosedOthers = 0;
    this.percentOthers = 0;
    this.valueOthers = 0;
    this.profitClosedTerm = 0;
    this.percentTerm = 0;
    this.valueTerm = 0;
    this.totalValueGraph = 0;
    this.positionSumary = [];
    this.chartOpts = false;
    this.model.filtersInputTab = inputTemp ? inputTemp : [];
    if (this.model.tabSelected === CustodyTabEnum.BOVESPA && this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_HISTORY) {
      this.showEmptyData = false;
    }
  }

  search() {
    if (this.model.tabSelected === CustodyTabEnum.PROVENTOS) {
      if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITION_CREDITED) {
        if (!this.model.initialDate || !this.model.endDate) {
          this._notificationService.warn('', 'A Data de Início e Data Fim devem ser informadas.');
          return false;
        } else
          if (this.model.initialDate > this.model.endDate) {
            this._notificationService.warn('', 'A Data de Início deve ser Menor que a Data Fim.');
            return false;
          } else if (this.model.endDate < this.model.initialDate) {
            this._notificationService.warn('', 'A Data Fim deve ser Maior que a Data de Início.');
            return false;
          }
      }
      this.loading = true;
      this.getEarnings(this.account, this.model.initialDate, this.model.endDate, this.model.tabFilterRadioValue);
    }
  }

  changeDate(inputSelect) {
    if (inputSelect && inputSelect.type === CustodyInputTypeEnum.INPUT_DATE) {
      if (inputSelect.webfeeder === 'initialDate') {
        this.model.initialDate = inputSelect.value;
      } else {
        this.model.endDate = inputSelect.value;
      }
    }
    if (this.model.tabSelected === CustodyTabEnum.BOVESPA) {
      if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_HISTORY && this.model.initialDate) {
        this.loading = true;
        this.showEmptyData = true;
        this.gridBovTablePositionHistory = [];
        this.getPortfolioHistory(this.model.initialDate);
      } else {
        this.showEmptyData = true;
      }
    } else if (
      this.model.tabSelected === CustodyTabEnum.PROVENTOS
      && this.model.tabFilterRadioSelected === CustodyFilterType.POSITION_PROVISIONED
    ) {
      this.model.initialDate = new Date();
      this.model.endDate = new Date();
      this.showInpuEmptytDate = false;
      this.search();
    } else if (
      this.model.tabSelected === CustodyTabEnum.PROVENTOS
      && this.model.tabFilterRadioSelected === CustodyFilterType.POSITION_CREDITED
    ) {
      this.showInpuEmptytDate = !this.model.initialDate || !this.model.endDate;
    }
  }

  validChar() {
    return false;
  }

  checkForBlank(value) {
    this.model.symbol = '';
  }

  selectAsset(value) {
    this.model.symbol = value.symbol;
  }

  close() {
    this.dialogRef.close();
  }

  subscribePositions() {
    if (this.account) {
      this.custodyCacheSubscription && this.custodyCacheSubscription.unsubscribe();
      this.custodySubscription && this.custodySubscription.unsubscribe();
      this.custodyCacheSubscription = this._positionService
        .subscribePosition(this.account, Constants.TITLE_CARD_MODAL_CUSTODY).pipe(take(1))
        .subscribe(data => {
          if (data) {
            if (data[Constants.MARKET_BOVESPA]) {
              this.convertToDisplayBovespa(data[Constants.MARKET_BOVESPA]);
            }
            if (data[Constants.MARKET_BMF]) {
              this.convertToDisplayBMF(data[Constants.MARKET_BMF]);
            }
          }
        });
      this.custodySubscription = this._positionService.messagesPosition
        .subscribe(positions => {
          const selectedMarket = this.model.tabSelected == 0 ? Constants.MARKET_BOVESPA : Constants.MARKET_BMF;
          if (positions && positions.length > 0) {
            if (positions[0].marketCode == selectedMarket) {
              if (selectedMarket === Constants.MARKET_BOVESPA) {
                this.convertToDisplayBovespa(positions);
              } else {
                this.convertToDisplayBMF(positions);
              }
            }
          }
        });
    }
  }

  calculateAndIncludesVariation(position, type: string) {
    if (!position.lastTrade || !position.previusTrade) {
      position.variation = '0,00';
      return position;
    }

    let previous: number, last: number;
    if (type === Constants.MARKET_BOVESPA) {
      previous = AppUtils.convertFormattedNumberToNumber(position.previusTrade);
      last = AppUtils.convertFormattedNumberToNumber(position.lastTrade);
    } else {
      previous = Number(position.previusTrade);
      last = Number(position.lastTrade);
    }

    const variation = last !== 0
      ? ((last / previous) - 1) * 100
      : 0;
    const formattedVariation = AppUtils.numberToFormattedNumber(variation, 2, ',');

    position.variation = (variation > 0 ? '+' : '') + formattedVariation;

    return position;
  }

  convertToDisplayBovespa(msgBov) {
    if (this.model.tabSelected === 0 && msgBov && msgBov.length > 0) {
      const presenterPositions = msgBov.map(position => this.calculateAndIncludesVariation(position, Constants.MARKET_BOVESPA));
      if ((this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_CURRENT && this.gridBovTablePositionCurrent && this.gridBovTablePositionCurrent.length === 0)
        || (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_DAY && this.gridBovTablePositionDay && this.gridBovTablePositionDay.length === 0)) {
        presenterPositions.forEach(position => {
          if ((position.quoteType === 'BTC-T') || (position.quoteType === 'BTC-D') || (position.quoteType === 'Cust.')) {
            position = this.convertHighLowClass(position);
            if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_CURRENT && (Number(position.currentQuantity) !== 0)
              || (Number(position.currentQuantity) !== 0) || (Number(position.currentQuantity) !== 0 && Number(position.initQuantity) !== 0
                || Number(position.quantityBlocked) !== 0 || Number(position.quantityD1) !== 0 || Number(position.quantityD2) !== 0
                || Number(position.quantityD3) !== 0 || Number(position.quantityReleased))) {
              this.gridBovTablePositionCurrent.push(position);
              this.gridBovTablePositionDay.push(position);
            } else if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_DAY) {
              this.gridBovTablePositionDay.push(position);
            }
          }
        });
      } else {
        presenterPositions.forEach(position => {
          if ((position.quoteType === 'BTC-T') || (position.quoteType === 'BTC-D') || (position.quoteType === 'Cust.')) {
            position = this.convertHighLowClass(position);
            const positionToEditCurrent = this.gridBovTablePositionCurrent.findIndex(item => item.quote === position['quote']);
            const positionToEditDay = this.gridBovTablePositionDay.findIndex(item => item.quote === position['quote']);
            if ((Number(position.currentQuantity) !== 0) || (Number(position.currentQuantity) !== 0) || (Number(position.currentQuantity) !== 0
              && Number(position.initQuantity) !== 0 || Number(position.quantityBlocked) !== 0 || Number(position.quantityD1) !== 0
              || Number(position.quantityD2) !== 0 || Number(position.quantityD3) !== 0 || Number(position.quantityReleased))) {
              if (positionToEditCurrent === -1) {
                this.gridBovTablePositionCurrent.push(position);
              } else {
                this.gridBovTablePositionCurrent[positionToEditCurrent] = position;
              }
              if (positionToEditDay === -1) {
                this.gridBovTablePositionDay.push(position);
              } else {
                this.gridBovTablePositionDay[positionToEditDay] = position;
              }
            } else {
              if (positionToEditDay === -1) {
                this.gridBovTablePositionDay.push(position);
              } else {
                this.gridBovTablePositionDay[positionToEditDay] = position;
              }
            }
          }
        });
      }
    }
    AppUtils.orderObjectStringAsc(this.gridBovTablePositionCurrent, 'quote');
    AppUtils.orderObjectStringAsc(this.gridBovTablePositionDay, 'quote');
  }

  convertToDisplayBMF(msgBmf) {
    if (this.model.tabSelected === 1 && msgBmf && msgBmf.length > 0) {
      const presenterPositions = msgBmf.map(position => this.calculateAndIncludesVariation(position, Constants.MARKET_BMF));
      if (
        (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_CURRENT && this.gridBmfTablePositionCurrent && this.gridBmfTablePositionCurrent.length === 0) ||
        (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_DAY && this.gridBmfTablePositionDay && this.gridBmfTablePositionDay.length === 0)
      ) {
        presenterPositions.forEach(position => {
          if ((position.quoteType === 'BTC-T') || (position.quoteType === 'BTC-D') || (position.quoteType === 'Cust.')) {
            position = this.convertHighLowClass(position);
            if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_CURRENT &&
              (position.quoteType === 'BTC-T' && Number(position.currentQuantity) !== 0) || (position.quoteType === 'BTC-D' && Number(position.currentQuantity) !== 0) ||
              (position.quoteType === 'Cust.' && Number(position.currentQuantity) !== 0 && Number(position.initQuantity) !== 0 || Number(position.quantityBlocked) !== 0 ||
                Number(position.quantityD1) !== 0 || Number(position.quantityD2) !== 0 || Number(position.quantityD3) !== 0 || Number(position.quantityReleased))) {
              this.gridBmfTablePositionCurrent.push(position);
              this.gridBmfTablePositionDay.push(position);
            } else if (this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_DAY) {
              this.gridBmfTablePositionDay.push(position);
            }
          }
        });
      } else {
        presenterPositions.forEach(position => {
          if ((position.quoteType === 'BTC-T') || (position.quoteType === 'BTC-D') || (position.quoteType === 'Cust.')) {
            position = this.convertHighLowClass(position);
            const positionToEditCurrent = this.gridBmfTablePositionCurrent.findIndex(item => item.quote === position['quote']);
            const positionToEditDay = this.gridBmfTablePositionDay.findIndex(item => item.quote === position['quote']);
            if ((Number(position.currentQuantity) !== 0) || (Number(position.currentQuantity) !== 0) ||
              (Number(position.currentQuantity) !== 0 && Number(position.initQuantity) !== 0 || Number(position.quantityBlocked) !== 0 ||
                Number(position.quantityD1) !== 0 || Number(position.quantityD2) !== 0 || Number(position.quantityD3) !== 0 || Number(position.quantityReleased))) {
              if (positionToEditCurrent === -1) {
                this.gridBmfTablePositionCurrent.push(position);
              } else {
                this.gridBmfTablePositionCurrent[positionToEditCurrent] = position;
              }
              if (positionToEditDay === -1) {
                this.gridBmfTablePositionDay.push(position);
              } else {
                this.gridBmfTablePositionDay[positionToEditDay] = position;
              }
            } else {
              if (positionToEditDay === -1) {
                this.gridBmfTablePositionDay.push(position);
              } else {
                this.gridBmfTablePositionDay[positionToEditDay] = position;
              }
            }
          }
        });
      }
      AppUtils.orderObjectStringAsc(this.gridBmfTablePositionCurrent, 'quote');
      AppUtils.orderObjectStringAsc(this.gridBmfTablePositionDay, 'quote');
    }
  }

  isBovespaPositionValidToDisplay(position) {
    const modelBovAux: BovModel = new BovModel();
    modelBovAux.quoteType = position.quoteType;
    modelBovAux.currentQuantity = position.currentQuantity.replace('.', '').replace(',', '.');
    modelBovAux.initQuantity = position.initQuantity.replace('.', '').replace(',', '.');
    modelBovAux.quantityBlocked = position.quantityBlocked.replace('.', '').replace(',', '.');
    modelBovAux.quantityD1 = position.quantityD1.replace('.', '').replace(',', '.');
    modelBovAux.quantityD2 = position.quantityD2.replace('.', '').replace(',', '.');
    modelBovAux.quantityD3 = position.quantityD3.replace('.', '').replace(',', '.');
    modelBovAux.quantityReleased = position.quantityReleased.replace('.', '').replace(',', '.');
    modelBovAux.initQuantityColor = AppUtils.parseFloat(position.initQuantity);
    modelBovAux.currentQuantityColor = AppUtils.parseFloat(position.currentQuantity);
    modelBovAux.quantityReleasedColor = AppUtils.parseFloat(position.quantityReleased);
    modelBovAux.quantityD1Color = AppUtils.parseFloat(position.quantityD1);
    modelBovAux.quantityD2Color = AppUtils.parseFloat(position.quantityD2);
    modelBovAux.quantityD3Color = AppUtils.parseFloat(position.quantityD3);
    return modelBovAux;
  }

  getPortfolioHistory(date) {
    if (date) {
      this._authServer.iNegotiation.portfolioHistory(this.account, date)
        .subscribe(res => {
          setTimeout(() => {
            if (res && res.length > 0 && res[0].positions && res[0].positions.length > 0) {
              res.forEach(element => {
                this.showEmptyData = false;
                this.showResult = true;
                this.loading = false;
                setTimeout(() => {
                  this.convertToDisplayHistory(element.positions);
                }, 50);
              });
            } else {
              this.showEmptyData = true;
              this.showResult = false;
              this.loading = false;
            }
          }, 100);
          this.loading = false;
        }, error => {
          if (error && error.message) {
            this._notificationService.error('', error.message);
          }
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }

  getEarnings(account, initialDate, endDate, tabFilterRadioSelected) {
    this.loading = true;
    this.wasEarningsCreditedFetched = true;
    if (account && initialDate && tabFilterRadioSelected >= 0) {
      this._authServer.iNegotiation
        .getEarnings(account, initialDate, endDate, tabFilterRadioSelected)
        .subscribe(res => {
          setTimeout(() => {
            if (res && res.length > 0 && res[0].positions && res[0].positions.length > 0) {
              res.forEach(element => {
                this.showEmptyData = false;
                this.showResult = true;
                setTimeout(() => {
                  if (Number(element.filterType) === CustodyEarningsFilterType.CREDITED) {
                    this.convertToDisplayEarningsCredited(element.positions);
                  } else {
                    this.convertToDisplayEarningsProvisioned(element.positions);
                  }
                }, 50);
              });
            } else {
              this.showEmptyData = true;
              this.showResult = false;
              this.loading = false;
            }
          }, 100);
          this.loading = false;
        }, error => {
          if (error && error.message) {
            this._notificationService.error('', error.message);
          }
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }

  convertToDisplayHistory(msgHistory) {
    if (this.model.tabSelected === 0 && msgHistory && msgHistory.length > 0) {
      const presenterHistory = [...msgHistory];
      if (this.gridBovTablePositionHistory.length === 0) {
        presenterHistory.forEach(history => {
          if (this.convertValidHistoryAndEarningToDisplay(history)) {
            this.gridBovTablePositionHistory.push(history);
          }
        });
      }
    }
  }

  convertToDisplayEarningsCredited(msgEarningsCredited) {
    if (this.model.tabSelected === 2 && msgEarningsCredited && msgEarningsCredited.length > 0) {
      const presenterEarningsCredited = [...msgEarningsCredited];
      if (this.gridEarningsCredited.length === 0) {
        presenterEarningsCredited.forEach(earningsCredited => {
          if (this.convertValidHistoryAndEarningToDisplay(earningsCredited)) {
            this.gridEarningsCredited.push(earningsCredited);
          }
        });
      }
    }
  }

  convertToDisplayEarningsProvisioned(msgEarningsProvisioned) {
    if (this.model.tabSelected === 2 && msgEarningsProvisioned && msgEarningsProvisioned.length > 0) {
      const presenterEarningsProvisioned = [...msgEarningsProvisioned];
      if (this.gridEarningsProvisioned.length === 0) {
        presenterEarningsProvisioned.forEach(earningsProvisioned => {
          if (this.convertValidHistoryAndEarningToDisplay(earningsProvisioned)) {
            this.gridEarningsProvisioned.push(earningsProvisioned);
          }
        });
      }
    }
  }

  convertValidHistoryAndEarningToDisplay(position) {
    position.quantity = position.quantity.replace('.', '').replace(',', '.');
    position.eventDate = position.eventDate ? this.convertStringToDateDefault(position.eventDate) : null;
    position.endDate = position.endDate ? this.convertStringToDateDefault(position.endDate) : null;
    position.liquidityDate = position.liquidityDate ? this.convertStringToDateDefault(position.liquidityDate) : null;
    if (this.model.tabSelected === CustodyTabEnum.BOVESPA && this.model.tabFilterRadioSelected === CustodyFilterType.POSITON_HISTORY) {
      position.portfolioType = Constants.CUSTODY_POSITION_TYPE.find(x => x.cod === Number(position.portfolioType)).desc;
    }
    return position;
  }

  convertStringToDateDefault(date: string) {
    if (date.length === 8) {
      const dateTemp = new Date(date.slice(0, 4) + '/' + date.slice(4, 6) + '/' + date.slice(6, 8));
      return this._datePipe.transform(dateTemp, 'dd/MM/yyyy');
    } else {
      return '-';
    }
  }

  renderNumber(param) {
    if (param && param.value) {
      const numberValue = param.data.marketCode == 'XBSP' ? AppUtils.parseFloat(param.value) || 0 : AppUtils.convertBrCurrencyToNumber(param.value, '.') || 0;
      return '<span>' + numberValue + '</span>'
    } else {
      return '0';
    }
  }

  convertHighLowClass(position) {
    position.openProfitLoss = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.openProfitLoss) || 0 : AppUtils.convertBrCurrencyToNumber(position.openProfitLoss, '.') || 0;
    position.closedProfitLoss = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.closedProfitLoss) || 0 : AppUtils.convertBrCurrencyToNumber(position.closedProfitLoss, '.') || 0;
    position.valueAdjustedAmount = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.valueAdjustedAmount) || 0 : AppUtils.convertBrCurrencyToNumber(position.valueAdjustedAmount, '.') || 0;
    position.executedBuy = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.executedBuy) || 0 : AppUtils.convertBrCurrencyToNumber(position.executedBuy, '.') || 0;
    position.executedSell = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.executedSell) || 0 : AppUtils.convertBrCurrencyToNumber(position.executedSell, '.') || 0;
    position.bruteValue = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.bruteValue) || 0 : AppUtils.convertBrCurrencyToNumber(position.bruteValue, '.') || 0;
    position.netDay = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.netDay) || 0 : AppUtils.convertBrCurrencyToNumber(position.netDay, '.') || 0;
    position.openBuy = position.openBuy === 'XBSP' ? AppUtils.parseFloat(position.openBuy) || 0 : AppUtils.convertBrCurrencyToNumber(position.openBuy, '.') || 0;
    position.openSell = position.openSell === 'XBSP' ? AppUtils.parseFloat(position.openSell) || 0 : AppUtils.convertBrCurrencyToNumber(position.openSell, '.') || 0;
    position.quantityBlocked = position.quantityBlocked === 'XBSP' ? AppUtils.parseFloat(position.quantityBlocked) || 0 : AppUtils.convertBrCurrencyToNumber(position.quantityBlocked, '.') || 0;
    position.quantityReleased = position.quantityReleased === 'XBSP' ? AppUtils.parseFloat(position.quantityReleased) || 0 : AppUtils.convertBrCurrencyToNumber(position.quantityReleased, '.') || 0;
    position.initQuantity = position.initQuantity === 'XBSP' ? AppUtils.parseFloat(position.initQuantity) || 0 : AppUtils.convertBrCurrencyToNumber(position.initQuantity, '.') || 0;
    position.currentQuantity = position.currentQuantity === 'XBSP' ? AppUtils.parseFloat(position.currentQuantity) || 0 : AppUtils.convertBrCurrencyToNumber(position.currentQuantity, '.') || 0;
    position.valueAdjustedAmountColor = position.marketCode === 'XBSP' ? AppUtils.parseFloat(position.valueAdjustedAmount) || 0 : AppUtils.convertBrCurrencyToNumber(position.valueAdjustedAmount, '.') || 0;
    position.initQuantityColor = AppUtils.parseFloat(position.initQuantity) || 0;
    position.currentQuantityColor = AppUtils.parseFloat(position.currentQuantity) || 0;
    position.quantityReleasedColor = AppUtils.parseFloat(position.quantityReleased) || 0;
    position.quantityD1Color = AppUtils.parseFloat(position.quantityD1) || 0;
    position.quantityD2Color = AppUtils.parseFloat(position.quantityD2) || 0;
    position.quantityD3Color = AppUtils.parseFloat(position.quantityD3) || 0;
    position.executedBuyColor = AppUtils.parseFloat(position.executedBuy) || 0;
    position.executedSellColor = AppUtils.parseFloat(position.executedSell) || 0;
    position.netDayColor = AppUtils.parseFloat(position.netDay) || 0;
    position.openProfitLossColor = AppUtils.parseFloat(position.openProfitLoss) || 0;
    position.closedProfitLossColor = AppUtils.parseFloat(position.closedProfitLoss) || 0;
    return position;
  }

  getPositionSumary(tabIndex) {
    this.positionSumary = [];
    this.totalValueGraph = 0;
    this._authServer.iNegotiation.positionBovespa(this.account, null)
      .subscribe(res => {
        if (res && res.custodyBovespa && res.custodyBovespa.length > 0) {
          let listQuotesTemp = '';
          let length = 0;
          res.custodyBovespa.forEach(element => {
            listQuotesTemp += element.quote.value;
            length++;
            if (length < res.custodyBovespa.length) {
              listQuotesTemp += '/';
            }
          });
          this._authServer.iQuote.getQuote(listQuotesTemp)
            .subscribe(resQuote => {
              for (let i = 0; i < resQuote.length; i++) { // lista de quotes
                const indexTemp = res.custodyBovespa.findIndex(x => x.quote.value.toLowerCase() === resQuote[i].symbol.toLowerCase());
                if (indexTemp >= 0) {
                  res.custodyBovespa[indexTemp].company = { value: resQuote[i].company };
                  res.custodyBovespa[indexTemp].parentSymbol = { value: resQuote[i].parentSymbol };
                }
              }
              this.formatResumePosition(res.custodyBovespa, tabIndex);
            }, () => {
              this._notificationService.error('', res.message ? res.message : Constants.MSG_LOGIN_MSG013);
              this.loadingGraph = false;
            });
        } else {
          this._notificationService.error('', res.message ? res.message : Constants.MSG_LOGIN_MSG013);
          this.loadingGraph = false;
        }
      }, error => {
        this._notificationService.error('', error.message ? error.message : Constants.MSG_LOGIN_MSG013);
        this.loadingGraph = false;
      });
  }

  private formatResumePosition(custodyBovespa, tabIndex) {
    custodyBovespa.forEach(element => {
      if (element) {
        if (element && element.company && element.company.value.toUpperCase().substring(0, 3) === 'FII') {
          this.valueFii = element.valueInit && element.valueInit.value ? this.valueFii + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueFii;
          this.profitClosedFii = element.closedProfitLoss && element.closedProfitLoss.value ? this.profitClosedFii + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedFii;
        } else if (element && element.securityType && element.securityType.value.toUpperCase().trim() === 'OPT'
          || (element && element.parentSymbol && element.parentSymbol.value && Number(element.parentSymbol.value) !== 0)) {
          this.valueOption = element.valueInit && element.valueInit.value
            ? this.valueOption + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueOption;
          this.profitClosedOption = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedOption + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedOption;
        } else if (element && element.securityType && element.securityType.value.toUpperCase().trim() === 'DTERM'
          || element && element.quote && element.quote.value.toUpperCase().substring(element.quote.value.length - 1, element.quote.value.length) === 'T') { // Termo: securityType = DTERM
          this.valueTerm = element.valueInit && element.valueInit.value
            ? this.valueTerm + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueTerm;
          this.profitClosedTerm = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedTerm + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedTerm;
        } else if (element && element.quoteType && element.quoteType.value.toUpperCase().trim() === 'BTC-T') {
          this.valueBtcT = element.valueInit && element.valueInit.value
            ? this.valueBtcT + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueBtcT;
          this.profitClosedBtcT = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedBtcT + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedBtcT;
        } else if (element && element.quoteType && element.quoteType.value.toUpperCase().trim() === 'BTC-D') {
          this.valueBtcD = element.valueInit && element.valueInit.value
            ? this.valueBtcD + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueBtcD;
          this.profitClosedBtcD = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedBtcD + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedBtcD;
        } else if (element && element.company && element.company.value.toUpperCase().indexOf('ISHARES') === 0 || element && element.company && element.company.value.toUpperCase().indexOf('ETF') === 0) {
          this.valueEtf = element.valueInit && element.valueInit.value
            ? this.valueEtf + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueEtf;
          this.profitClosedEtf = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedEtf + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedEtf;
        } else if (element && element.quoteType && element.quoteType.value.toUpperCase().trim() === 'DRN'
          || element && element.quote && element.quote.value.toUpperCase().substring(element.quote.value.length - 2, element.quote.value.length) === '34') {
          this.valueBdr = element.valueInit && element.valueInit.value
            ? this.valueBdr + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueBdr;
          this.profitClosedBdr = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedBdr + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedBdr;
        } else if (element && element.quoteType && element.quoteType.value.toUpperCase().trim() === 'CUST.' || element && element.securityType && element.securityType.value === 'SPOT') {
          this.valueActions = element.valueInit && element.valueInit.value
            ? this.valueActions + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueActions;
          this.profitClosedActions = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedActions + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedActions;
        } else {
          this.valueOthers = element.valueInit && element.valueInit.value
            ? this.valueOthers + AppUtils.convertFormattedNumberToNumber(element.valueInit.value) : this.valueOthers;
          this.profitClosedOthers = element.closedProfitLoss && element.closedProfitLoss.value
            ? this.profitClosedOthers + AppUtils.convertFormattedNumberToNumber(element.closedProfitLoss.value) : this.profitClosedOthers;
        }
      }
    });
    this.buildChart(tabIndex);
  }

  private buildChart(tabIndex: number) {
    this.chartOpts = {
      chart: {
        backgroundColor: 'transparent',
        borderWidth: 0,
        events: {
          redraw: function (e) {
            e.preventDefault();
          }
        },
        height: window.innerHeight <= 768 ? 300 : 350,
        width: window.innerWidth <= 1500 ? 300 : '',
        class: 'back-teste',
        plotBackgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
        renderTo: 'chart',
        type: 'pie',
      },
      plotOptions: {
        pie: {
          borderWidth: 0,
          borderColor: null,
          allowPointSelect: true,
          plotBorderWidth: 0,
          color: 'transparent',
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          innerSize: '50%',
          plotShadow: false,
          point: {
            events: {
              legendItemClick: function (e) {
                e.preventDefault();
              }
            }
          },
          showInLegend: false,
          type: 'pie',
        },
      },
      series: [{
        colorByPoint: true,
        data: this.setValuesToChart(tabIndex),
        enableMouseTracking: false,
        events: {
          legendItemClick: false
        },
        name: 'CustodyPositionSumary',
      }],
      title: { text: null, subtitle: '' },
    };
    setTimeout(() => {
      if (tabIndex === CustodyFilterType.ASSET_CLASS && this.chartElClass) {
        Highcharts.chart(this.chartElClass.nativeElement, this.chartOpts);
        Highcharts.charts[(Highcharts.charts.length - 1)].update({});
      }
      // TODO: Aguardando serviço ser desenvolvido no OMS e WF
      // else if (tabIndex === CustodyFilterType.ASSET_SECTOR && this.chartElSector) {
      //     Highcharts.chart(this.chartElSector.nativeElement, this.chartOpts);
      //     Highcharts.charts[(Highcharts.charts.length - 1)].update({});
      //   }
    }, 100);
  }

  private setValuesToChart(tabIndex) {
    const theme = window.sessionStorage.getItem(Constants.LAYOUT_THEME_DARK) === 'true' ? 'dark' : 'light';
    const bodyStyles = window.getComputedStyle(document.body);
    const actions = bodyStyles.getPropertyValue(`--color-${theme}-stocks`);
    const bdr = bodyStyles.getPropertyValue(`--color-${theme}-custody`);
    const cash = bodyStyles.getPropertyValue(`--color-${theme}-foresight`);
    const btc = bodyStyles.getPropertyValue(`--color-${theme}-funds`);
    const etf = bodyStyles.getPropertyValue(`--color-${theme}-guarantee`);
    const fii = bodyStyles.getPropertyValue(`--color-${theme}-earnings`);
    const option = bodyStyles.getPropertyValue(`--color-${theme}-clubs`);
    const others = bodyStyles.getPropertyValue(`--color-${theme}-treasure`);
    const term = bodyStyles.getPropertyValue(`--color-${theme}-fixed-income`);
    const colorDesignedOnline = bodyStyles.getPropertyValue(`--color-${theme}-designed-online`);
    if (tabIndex === CustodyFilterType.ASSET_CLASS) {
      this.positionSumary = [
        { name: 'A Vista', y: this.valueActions, percent: this.percentActions, profitClosed: this.profitClosedActions, color: actions, class: 'actions' },
        { name: 'BDR', y: this.valueBdr, percent: this.percentBdr, profitClosed: this.profitClosedBdr, color: bdr, class: 'bdr' },
        { name: 'BTC-D', y: this.valueBtcD, percent: this.percentBtcD, profitClosed: this.profitClosedBtcD, color: cash, class: 'cash' },
        { name: 'BTC-T', y: this.valueBtcT, percent: this.percentBtcT, profitClosed: this.profitClosedBtcT, color: btc, class: 'btc' },
        { name: 'ETF', y: this.valueEtf, percent: this.percentEtf, profitClosed: this.profitClosedEtf, color: etf, class: 'etf' },
        { name: 'FII', y: this.valueFii, percent: this.percentFii, profitClosed: this.profitClosedFii, color: fii, class: 'fii' },
        { name: 'Opção', y: this.valueOption, percent: this.percentOption, profitClosed: this.profitClosedOption, color: option, class: 'option' },
        { name: 'Outros', y: this.valueOthers, percent: this.percentOthers, profitClosed: this.profitClosedOthers, color: others, class: 'others' },
        { name: 'Termo', y: this.valueTerm, percent: this.percentTerm, profitClosed: this.profitClosedTerm, color: term, class: 'term' },
      ];
      this.totalValueGraph = this.valueFii + this.valueOption + this.valueTerm + this.valueBtcT + this.valueBtcD
        + this.valueBdr + this.valueEtf + this.valueActions + this.valueOthers;
    }
    // TODO: Aguardando serviço ser desenvolvido no OMS e WF
    // else if (tabIndex === CustodyFilterType.ASSET_SECTOR) {
    // this.positionSumary = [
    //   { name: 'Petroleo, Gas e Biocombustiveis', y: 500, percent: 0, profitClosed: 0, color: actions, class: 'actions' },
    //   { name: 'Materiais Basicos', y: 123, percent: 0, profitClosed: 0, color: fii, class: 'fii' },
    //   { name: 'Bens Industriais', y: 500, percent: 0, profitClosed: 0, color: option, class: 'option' },
    //   { name: 'Construcao e Transporte', y: 33, percent: 0, profitClosed: 0, color: term, class: 'term' },
    //   { name: 'Consumo Nao Ciclico', y: 45, percent: 0, profitClosed: 0, color: btc, class: 'btc' },
    //   { name: 'Consumo Ciclico', y: 247, percent: 0, profitClosed: 0, color: bdr, class: 'bdr' },
    //   { name: 'Tecnologia da Informacao', y: 70, percent: 0, profitClosed: 0, color: etf, class: 'etf' },
    //   { name: 'Telecomunicacoes', y: 300, percent: 0, profitClosed: 0, color: others, class: 'others' },
    //   { name: 'Utilidade Publica', y: 300, percent: 0, profitClosed: 0, color: actions, class: 'actions' },
    //   { name: 'Financeiro e Outros', y: 300, percent: 0, profitClosed: 0, color: fii, class: 'fii' },
    // ];
    // }
    if (this.positionSumary && this.positionSumary.length > 0) {
      this.positionSumary.forEach(element => {
        element.percent = (element.y / this.totalValueGraph);
        if (element.y !== 0) {
          this.showGraph = true;
        }
      });
    }
    AppUtils.orderObjectAsc(this.positionSumary, 'name');
    this.loadingGraph = false;
    return this.positionSumary.filter(item => item.y !== 0);
  }

  openBillet(billetType?: string, position?: any) {
    const posTemp = Number(position.netDay);
    let loteSizeOrder = null;
    if (billetType === SideEnum.BUY) { //Operação compra
      if (posTemp < 0) { // Se estiver vendido ->  Abrir a boleta de COMPRA com a quantidade da custódia;
        loteSizeOrder = posTemp;
      }
    }
    if (billetType === SideEnum.SELL) { // Operação de venda
      if (posTemp > 0) { // Se estiver comprado -> Abrir a boleta de VENDA com a quantidade da custódia;
        loteSizeOrder = posTemp;
      }
    }

    loteSizeOrder = (loteSizeOrder < 0) ? loteSizeOrder * -1 : loteSizeOrder;

    this.dialogRef.close();
    this._billetOrderService.buySellOrder(billetType, position.quote, position.lastTrade, null, loteSizeOrder);
  }


}
